import videojs from 'video.js'
window['videojs'] = videojs

require('videojs-contrib-quality-levels')
require('videojs-hls-quality-selector')
require('videojs-youtube')
require('@/helpers/video-player/vimeo.js')

export default {
    config(video, options) {
        var videoPlayer = videojs(video)
        videoPlayer.src(options.src)
        videoPlayer.hlsQualitySelector()
        videoPlayer.options_.techOrder = options.techOrder
        videoPlayer.fill(true)
        if (options.hasOwnProperty('poster'))
            videoPlayer.poster(options.poster)
        return videoPlayer
    }
}